module.exports = __webpack_public_path__ + "img/music-flash.78829b74.png";